<template>
  <div class="traffic_road-graphics">
    <div 
      class="traffic_road-graphics-item"
    > 

      <CastomGraphic
          :received-data="receivedDataFirst"
          graph-type="line"
          index-axis="x"
          :id="'traffic-road-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div> 

    <div 
      class="traffic_road-graphics-item"
    >
      <CastomGraphic
            :received-data="receivedDataSecond"
            graph-type="bar"
            index-axis="y"
            :id="'traffic-road-2'"
            :aspect-ratio="1"
            :maintain-aspect-ratio="true"
        />
    </div>
  </div>
</template>
<script>

export default {
  name: 'RowCustomGraphic',
  props: {
    receivedData: {
      type: [Array, Object],
      required: true
    }
  },
  computed: {
    receivedDataSecond () {
      let key = Object.keys(this.receivedData)[1]
      return this.receivedData[key]
    },
    receivedDataFirst () {
      let key = Object.keys(this.receivedData)[0]
      return this.receivedData[key]
    }
  },
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  }
}
</script>
<style lang="scss" scoped>
  .traffic_road-graphics {
    display: flex;
    @media (max-width: 600px) {
        flex-direction: column;
    }

    &-item {
      width: 50%;

      @media (max-width: 600px) {
        width: 100%;
      }
    }
  }
</style>